import { render, staticRenderFns } from "./StudentViewTabClass.vue?vue&type=template&id=4eb56dc5&"
import script from "./StudentViewTabClass.vue?vue&type=script&lang=js&"
export * from "./StudentViewTabClass.vue?vue&type=script&lang=js&"
import style0 from "./StudentViewTabClass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports